import styled from 'styled-components';

interface Props {
  readonly className?: string;
  readonly children?: React.ReactNode;
}

const Wrapper = styled.div`
  margin-right: 8px;
`;

const NewsFeedItemThumbnail: React.FC<Props> = props => {
  return <Wrapper className={props.className}>{props.children}</Wrapper>;
};

export default NewsFeedItemThumbnail;
